/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * User Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Permissions schema for update
 * @export
 * @interface PermissionsUpdate
 */
export interface PermissionsUpdate {
    /**
     * @type {string}
     * @memberof PermissionsUpdate
     */
    name: string;
    /**
     * @type {string}
     * @memberof PermissionsUpdate
     */
    dm_zone: string;
    /**
     * @type {string}
     * @memberof PermissionsUpdate
     */
    dm_device: string;
    /**
     * @type {string}
     * @memberof PermissionsUpdate
     */
    user_management: string;
    /**
     * @type {string}
     * @memberof PermissionsUpdate
     */
    fmw_management: string;
    /**
     * @type {string}
     * @memberof PermissionsUpdate
     */
    http_sender: string;
    /**
     * @type {string}
     * @memberof PermissionsUpdate
     */
    rmq_sender: string;
    /**
     * @type {string}
     * @memberof PermissionsUpdate
     */
    monitoring: string;
    /**
     * @type {string}
     * @memberof PermissionsUpdate
     */
    raw_messages: string;
    /**
     * @type {string}
     * @memberof PermissionsUpdate
     */
    devices?: string;
    /**
     * @type {string}
     * @memberof PermissionsUpdate
     */
    stations?: string;
    /**
     * @type {string}
     * @memberof PermissionsUpdate
     */
    provisioning?: string;
    /**
     * @type {boolean}
     * @memberof PermissionsUpdate
     */
    template?: boolean;
    /**
     * Only for admin
     * @type {number}
     * @memberof PermissionsUpdate
     */
    owner_id?: number;
}
